module.exports = __webpack_public_path__ + "img/SKWINKELNetActieCampagneplanningA1BD39.f27a986d.png";